import { memo } from "react";
import { Box, Typography } from "@mui/material";
import theme from "themeProvider";
import { StatusChip } from "components";
import { STATUS_CHIP } from "constants";

const TimelineHeader = ({ isConnected, connectionError, eventCount }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 3,
      py: 2.5,
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
    }}
  >
    <Box>
      <Typography sx={{ fontSize: 20, fontWeight: 700 }}>
        Live Event Tracking
      </Typography>
      <Typography
        sx={{ fontSize: 13, color: theme.palette.text.secondary, mt: 0.25 }}
      >
        Real-time updates of all events
      </Typography>
    </Box>
    <Box display="flex" alignItems="center" gap={2}>
      <StatusChip
        type={isConnected ? STATUS_CHIP.success : STATUS_CHIP.error}
        label={isConnected ? "Connected" : "Disconnected"}
      />
      {!!connectionError && (
        <Typography color="error" fontSize={13}>
          {String(connectionError)}
        </Typography>
      )}
      <Typography sx={{ fontSize: 13, color: theme.palette.text.secondary }}>
        {eventCount} events received
      </Typography>
    </Box>
  </Box>
);

export default memo(TimelineHeader);
